import React, { useState, useRef } from 'react';

const services = [
  {
    id: 'clean',
    title: 'Home clean',
    price: '$35 / hr',
    gradient: 'linear-gradient(135deg, #EDE8FB 0%, #D4CAF0 100%)',
    iconColor: '#7B6EC4',
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#7B6EC4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 22V12h4v10M9 22V8h4v14M15 22V4h4v18"/>
        <path d="M3 22h18"/>
      </svg>
    ),
    back: 'Weekly cleans, maintenance, or one-offs. I use your own cleaning products and equipment — no markup, and your home stays the way you like it. Kitchen, bathrooms, vacuum, mop, surfaces, bins — tell me what matters to you and I\'ll fit a plan around the time. Deep cleans and oven cleans on request, quoted separately.',
  },
  {
    id: 'pets',
    title: 'Pet care',
    price: '$30 / hr',
    gradient: 'linear-gradient(135deg, #E8F4F0 0%, #C8E6DA 100%)',
    iconColor: '#3A5A48',
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#3A5A48" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 5.172C10 3.782 8.884 2.5 7.5 2.5S5 3.782 5 5.172c0 1.39.884 2.328 2.5 2.328S10 6.562 10 5.172z"/>
        <path d="M19 5.172C19 3.782 17.884 2.5 16.5 2.5S14 3.782 14 5.172c0 1.39.884 2.328 2.5 2.328S19 6.562 19 5.172z"/>
        <path d="M6.5 11.5c-1.38 0-2.5 1.12-2.5 2.5 0 1.38 1.12 2.5 2.5 2.5"/>
        <path d="M17.5 11.5c1.38 0 2.5 1.12 2.5 2.5 0 1.38-1.12 2.5-2.5 2.5"/>
        <path d="M12 22c3 0 5-2.5 5-5.5 0-2-1.5-4-3-5s-2.5-2-2-4c-.5 2-.5 3-2 4s-3 3-3 5c0 3 2 5.5 5 5.5z"/>
      </svg>
    ),
    back: 'Walks, vet drop-offs, groomer trips, mid-day check-ins. I\'m comfortable with large breeds — my own dog is professionally trained, and I was trained alongside her. Tell me what your dog needs: a quick stroll, a proper exercise session up the hills, or something gentle if they\'re older or have health conditions. Happy to take your doggie for a wash at PetStore Ferrymead — I just pass the cost on at-cost.',
  },
  {
    id: 'childcare',
    title: 'Childcare',
    price: '$30 / hr',
    gradient: 'linear-gradient(135deg, #FFF5E8 0%, #FDECD4 100%)',
    iconColor: '#C17A3A',
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#C17A3A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/>
        <path d="M6 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"/>
      </svg>
    ),
    back: 'Going for a night out? Need someone to look after the kids, or a pick-up or drop-off locally? Full NZ driver\'s licence, First Aid certified, Fire Warden trained, and happy to share my clean Ministry of Justice criminal record check on request. References from the community available too.',
  },
  {
    id: 'errands',
    title: 'Errands & groceries',
    price: '$30 / hr',
    gradient: 'linear-gradient(135deg, #E8F0F8 0%, #C8DAF0 100%)',
    iconColor: '#4A5A8A',
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#4A5A8A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 01-8 0"/>
      </svg>
    ),
    back: 'Weekly grocery run or pick-up, pharmacy, post office, returns, parcel pickups, dry cleaning — whatever you\'d usually do on a Saturday morning but don\'t want to. Petrol and parking included within Sumner, Redcliffs, Mt Pleasant and Ferrymead. Anywhere further afield, just ask.',
  },
];

function FlipCard({ service }) {
  const [flipped, setFlipped] = useState(false);
  const touchRef = useRef(false);

  const handleMouseEnter = () => {
    if (!touchRef.current) setFlipped(true);
  };
  const handleMouseLeave = () => {
    if (!touchRef.current) setFlipped(false);
  };
  const handleTouchStart = () => {
    touchRef.current = true;
  };
  const handleClick = () => {
    if (touchRef.current) setFlipped((f) => !f);
  };

  return (
    <div
      className="flip-card"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onClick={handleClick}
    >
      <div className={`flip-card-inner ${flipped ? 'flipped' : ''}`}>
        {/* Front */}
        <div className="flip-card-front" style={{ background: service.gradient }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '1.5rem',
            textAlign: 'center',
          }}>
            <div style={{ marginBottom: '1rem', opacity: 0.85 }}>
              {service.icon}
            </div>
            <div style={{
              fontWeight: 600,
              fontSize: '1rem',
              color: '#1A1530',
              marginBottom: '0.4rem',
            }}>
              {service.title}
            </div>
            <div style={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 600,
              fontSize: '1.3rem',
              color: '#C17A3A',
            }}>
              {service.price}
            </div>
            <div style={{
              fontSize: '0.72rem',
              color: '#6A6080',
              marginTop: '0.75rem',
              fontStyle: 'italic',
            }}>
              {touchRef.current ? 'Tap for details' : 'Hover for details'}
            </div>
          </div>
        </div>

        {/* Back */}
        <div className="flip-card-back" style={{
          background: '#fff',
          border: '0.5px solid #E8E0F0',
        }}>
          <div style={{
            padding: '1.25rem',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            overflowY: 'auto',
          }}>
            <div style={{
              fontWeight: 600,
              fontSize: '0.9rem',
              color: service.iconColor,
              marginBottom: '0.6rem',
            }}>
              {service.title}
            </div>
            <p style={{
              fontSize: '0.82rem',
              fontWeight: 300,
              color: '#6A6080',
              lineHeight: 1.65,
              margin: 0,
            }}>
              {service.back}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ServicesOverview() {
  return (
    <section id="home-help" style={{
      background: 'linear-gradient(90deg, #F0ECFC 0%, #E8F4F8 100%)',
      padding: '3.5rem 0',
    }}>
      <div className="content-column">
        <div className="section-tag">Home & life help</div>
        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
          fontSize: '1.75rem',
          lineHeight: 1.2,
          color: '#1A1530',
          marginTop: 0,
          marginBottom: '0.5rem',
        }}>
          What can I take off your{' '}
          <em style={{ fontWeight: 400, color: '#7B6EC4' }}>plate?</em>
        </h2>
        <p style={{
          fontSize: '0.93rem',
          fontWeight: 300,
          color: '#6A6080',
          lineHeight: 1.7,
          marginTop: 0,
          marginBottom: '0.5rem',
          maxWidth: '560px',
        }}>
          Let me take the weekly stuff off your hands — cleaning, errands, groceries, pet care, and more. Customise it around what you actually need. Or just book a one-off when life throws something at you.
        </p>
        <p style={{
          fontSize: '0.83rem',
          fontWeight: 400,
          fontStyle: 'italic',
          color: '#7B6EC4',
          marginTop: 0,
          marginBottom: '1.75rem',
        }}>
          No commitment, no fuss. Book a single session whenever it suits.
        </p>

        {/* Flip cards grid */}
        <div className="flip-cards-grid">
          {services.map((service) => (
            <FlipCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}
